/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import { Card, CardProps } from '@mantine/core'

function BreadcrumbCard (props: CardProps) {
  const { children, ...others } = props
  return (
    <Card mb="sm" {...others}>
      {children}
    </Card>
  )
}

export default BreadcrumbCard
